import React, { useRef } from 'react'
import {
  SiGithub,
  SiLinkedin,
  SiMaildotru,
  SiTelegram,
  SiReact,
  SiTypescript,
  SiSass,
  //SiNodedotjs,
} from "react-icons/si";
import gsapIcon from "../../assets/GSAP.svg"
import { useTranslation, Trans } from "react-i18next";

import "./Footer.scss";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const {t} = useTranslation();
  const contactsData = [
    /* {
      title: "See a upWork profile",
      link: "",
      icon: <SiUpwork />,
    }, */
    {
      id: 1,
      title: "See a LinkedIn profile",
      link: "https://www.linkedin.com/in/mariia-opanasenko/",
      icon: <SiLinkedin />,
    },
    {
      id: 2,
      title: "See a GitHub profile",
      link: "https://github.com/pensativa",
      icon: <SiGithub />,
    },
    {
      id: 3,
      title: "Send a message in telegram",
      link: "https://t.me/pensativa",
      icon: <SiTelegram />,
    },
    {
      id: 4,
      title: "Send a email to me",
      link: "mailto:hi@pensativa.tech",
      icon: <SiMaildotru />,
    },
  ];
  
  const title = useRef(null);
  const text = useRef(null);
  const container = useRef(null);
  const copyrights = useRef(null);
  const experienceList = useRef('.contacts__item')

  useGSAP(() => {
    gsap.set(text.current, {xPercent: -100, opacity: 0})
    gsap.to(text.current, {
      scrollTrigger: text.current,
      opacity: 1, 
      xPercent: 0, 
      duration: 1, 
      delay: 0.5,
      ease: "slow",
    });
    gsap.set(title.current, {xPercent: -100, opacity: 0})
    gsap.to(title.current, {
      scrollTrigger: title.current,
      opacity: 1, 
      xPercent: 0, 
      duration: 1, 
      ease: "slow",
    });
    gsap.fromTo(experienceList.current, {
      opacity: 0,
      yPercent: 100
    }, {
      scrollTrigger: experienceList.current,
      opacity: 1,
      yPercent: 0,
      duration: 1, 
      ease: "slow", 
      stagger: 0.2,
      delay: 1 
    });
    gsap.set(copyrights.current, {yPercent: 100, opacity: 0})
    gsap.to(copyrights.current, {
      scrollTrigger: copyrights.current,
      opacity: 1, 
      yPercent: 0, 
      duration: 1,
      delay: 1.5,
      ease: "slow",
    });
  }, { scope: container })

  return (
    <footer className="contacts" id="contacts">
      <div className="container contacts__description">
        <h2 className="app__title contacts__title center" ref={title}>
          <Trans i18nKey="contacts_title">
            Contacts
          </Trans>
        </h2>
        <p className="contacts__description-text" ref={text}>{t('contacts_description')}</p>
        <ul
          className="contacts__list"
          ref={container}
        >
          {contactsData.map((item) => (
            <li key={item.id}>
              <a
                className="contacts__item"
                href={`${item.link}`}
                target="_blank"
                rel="noreferrer"
                title={`${item.title}`}
              >
                {item.icon}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div
        className="contacts__info container center"
        ref={copyrights}
      >
        <p>
          <Trans i18nKey="footer_title">
            Mariia Opanasenko - Frontend | React | Web developer
          </Trans>
        </p>
        <div className="contacts__tools">
          <SiReact /> <SiTypescript /> <SiSass /> 
          <img src={`${gsapIcon}`} alt="GSAP" width={16} height={16} />
        </div>
        <p className="contacts__privat">© {new Date().getFullYear()}, <Trans i18nKey="footer_rights">ALL RIGHTS RESERVED</Trans></p>
      </div>
    </footer>
  );
}

export default Footer